module.exports = __webpack_public_path__ + "static/media/07.4ba778d6.mp3";